export default function CreateAccountDark() {
  return (
    <>
      <button className="btn btn-dark">Create Account</button>
    </>
  )
}
